import {CLEAR_GLOBAL_MASK} from '../../constants';

export type ClearGlobalMaskAction = {
    /**
     * The action type
     */
    type : typeof CLEAR_GLOBAL_MASK;

    /**
     * The name of the mask
     */
    name : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} name           The name of the mask
 *
 * @return {ClearGlobalMaskAction}
 */
const clearGlobalMask = ( name : string ) : ClearGlobalMaskAction => {
    return {
        type: CLEAR_GLOBAL_MASK,
        name
    };
}
export type ClearGlobalMask = typeof clearGlobalMask;

export default clearGlobalMask;
